let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("81M7j")).then(() => parcelRequire('cO2Fz'));